import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({
    children,
    delay = 0,
    y = 40,
    className = "",
    as = "div",
}) => {
    const Tag = motion[as] || motion.div;
    return (
        <Tag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </Tag>
    );
};

export const Eyebrow = ({ children, color = "text-[#00CFFF]" }) => (
    <p
        className={`font-mono2 text-xs md:text-sm tracking-[0.25em] uppercase ${color}`}
    >
        {children}
    </p>
);

export { EASE };
